// Funnel "How It Works" step icons — the React side of the funnel_icons
// contract. The curated allowlist + human labels live in
// config/funnel_icons.json (the single source, also read by the Ruby
// FunnelIcons reader and advertised by the MCP server). This module supplies
// the actual Tabler React component for each entry and DERIVES the name->
// component map from the JSON — there is no parallel hand-maintained name list.
//
// funnel_icons_spec.rb asserts name<->component parity: every JSON `tabler`
// value has a component in TABLER_COMPONENTS below, and every component here is
// referenced by a JSON entry (zero orphans on either side). Adding a name to
// only one file fails that spec.
import {
  IconCash,
  IconCoin,
  IconCreditCard,
  IconReceipt,
  IconReportMoney,
  IconSearch,
  IconForms,
  IconFileText,
  IconChecklist,
  IconWritingSign,
  IconGavel,
  IconScale,
  IconShieldCheck,
  IconLock,
  IconUserCheck,
  IconUsers,
  IconId,
  IconMail,
  IconPhone,
  IconClock,
  IconHourglass,
  IconCalendarEvent,
  IconCircleCheck,
  IconThumbUp,
  IconAlertTriangle,
  IconHelpCircle,
  IconBuildingBank,
  IconMapPin,
} from "@tabler/icons-react"
import FUNNEL_ICONS from "../../../config/funnel_icons.json"

// Explicit (tree-shakeable) component imports, keyed by their Tabler export
// name. Only this object is hand-maintained on the JS side; the allowlist and
// labels stay in the JSON. The parity spec ties the two together.
const TABLER_COMPONENTS = {
  IconCash,
  IconCoin,
  IconCreditCard,
  IconReceipt,
  IconReportMoney,
  IconSearch,
  IconForms,
  IconFileText,
  IconChecklist,
  IconWritingSign,
  IconGavel,
  IconScale,
  IconShieldCheck,
  IconLock,
  IconUserCheck,
  IconUsers,
  IconId,
  IconMail,
  IconPhone,
  IconClock,
  IconHourglass,
  IconCalendarEvent,
  IconCircleCheck,
  IconThumbUp,
  IconAlertTriangle,
  IconHelpCircle,
  IconBuildingBank,
  IconMapPin,
}

// name -> React component, derived from the JSON (no second name list to drift).
const iconMap = Object.fromEntries(
  FUNNEL_ICONS.map(({ name, tabler }) => [name, TABLER_COMPONENTS[tabler]]).filter(
    ([, component]) => component,
  ),
)

export default iconMap

// Picker options for the admin Select: { value: <name>, label: <human label> },
// straight from the JSON so the choices and the renderer never diverge. The
// glyph rendering + the Select itself live in StepIconSelect.jsx (one shared
// picker, not a per-form fork) — this module stays pure data (no JSX) so it can
// be a plain .js consumed by both the picker and the parity spec.
export const ICON_OPTIONS = FUNNEL_ICONS.map(({ name, label }) => ({ value: name, label }))
